import { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { LOGO_URL } from "@/lib/api";
import { ChevronDown, Home, FileText, Gamepad2, MapPin, LayoutGrid, Newspaper, Sparkles } from "lucide-react";

const SERVICES = [
  { to: "/", label: "Accueil", icon: Home, testid: "menu-home" },
  { to: "/estimation", label: "Estimer mon bien", icon: FileText, testid: "menu-estimation" },
  { to: "/#projet", label: "Votre projet sur mesure", icon: Sparkles, testid: "menu-projet" },
  { to: "/actualites", label: "Actualités & Conseils Immo", icon: Newspaper, testid: "menu-actualites" },
  { to: "/jeu", label: "Le Juste Prix Immo", icon: Gamepad2, testid: "menu-jeu" },
  { to: "/carte", label: "Carte des prix au m²", icon: MapPin, testid: "menu-carte" },
];

export const Header = () => {
  const loc = useLocation();
  const onAdmin = loc.pathname.startsWith("/admin");
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-slate-200/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
          <img src={LOGO_URL} alt="Les Yeux Dans L'Immo" className="h-12 w-12 object-contain" />
          <div className="leading-none min-w-0">
            <div className="font-display font-extrabold text-base sm:text-lg tracking-tight text-slate-900 whitespace-nowrap">
              Les Yeux <span className="text-[#2563EB]">Dans L'Immo</span>
            </div>
            <div className="text-[9px] sm:text-[10px] uppercase tracking-[0.18em] sm:tracking-[0.25em] text-slate-400 mt-0.5">
              Auvergne-Rhône-Alpes
            </div>
          </div>
        </Link>

        <nav className="flex items-center gap-3">
          {!onAdmin && (
            <>
              <div className="relative" ref={ref}>
                <button
                  onClick={() => setOpen((o) => !o)}
                  data-testid="services-menu-btn"
                  className="flex items-center gap-2 border border-slate-300 bg-white hover:bg-slate-50 text-slate-800 px-4 py-2.5 rounded-lg font-medium text-sm transition-colors"
                >
                  <LayoutGrid className="w-4 h-4 text-[#2563EB]" strokeWidth={2} />
                  Services
                  <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
                </button>
                {open && (
                  <div
                    className="absolute right-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-slate-100 p-2 animate-fadeup"
                    data-testid="services-menu"
                  >
                    <div className="px-3 py-2 text-[10px] uppercase tracking-[0.2em] text-slate-400">Nos services</div>
                    {SERVICES.map((s) => (
                      <Link
                        key={s.to}
                        to={s.to}
                        onClick={() => setOpen(false)}
                        data-testid={s.testid}
                        className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-slate-50 text-slate-700 text-sm font-medium transition-colors"
                      >
                        <span className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center">
                          <s.icon className="w-4 h-4 text-[#2563EB]" strokeWidth={1.75} />
                        </span>
                        {s.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link
                to="/estimation"
                data-testid="header-estimate-btn"
                className="hidden sm:inline-flex bg-slate-900 text-white hover:bg-slate-800 px-5 py-2.5 rounded-lg font-medium text-sm transition-colors items-center"
              >
                Estimer mon bien
              </Link>
            </>
          )}
          {onAdmin && (
            <span className="text-xs uppercase tracking-[0.2em] text-slate-400">Espace Admin</span>
          )}
        </nav>
      </div>
    </header>
  );
};
